export enum DeliveryMethod {
	Chauffeur,
	Mail
}
